import { Route, Routes } from 'react-router-dom'
import {
  LayoutWrapper,
  NoHeaderLayoutWrapper,
  SelectedCloudIcon,
} from '@labrav/common'
import { PartnerAccountDataProvider } from '../PartnerAccountDataProvider/PartnerAccountDataProvider'
import { lazy, Suspense } from 'react'
import { DetailProductListing } from '../../components/DetailProductListing/DetailProductListing'
import { BaseRouteWithAccountRedirect } from '../BaseRouteWithAccountRedirect/BaseRouteWithAccountRedirect'
import {
  ProductListingV2,
  ExternalPlatformType,
} from '../../components/ProductListingV2'

const ImpartnerProductListingWrapper = () => (
  <PartnerAccountDataProvider isExternal={true}>
    <Suspense fallback={<div>Loading...</div>}>
      <ProductListingV2 externalPlatformType={ExternalPlatformType.IMPARTNER} />
    </Suspense>
  </PartnerAccountDataProvider>
)

const AddEditProductListingWrapper = lazy(() =>
  import('../../components/AddEditProduct/AddEditProductListingWrapper').then(
    module => ({
      default: module.AddEditProductListingImpartnerWrapper,
    })
  )
)

export const ExternalPartnerRoutes = () => {
  return (
    <PartnerAccountDataProvider isExternal={true}>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route
            path="flyout/products-listing"
            element={
              <LayoutWrapper
                title=""
                component={() => (
                  <BaseRouteWithAccountRedirect
                    product="flyout"
                    resource="products-listing"
                  />
                )}
                isExternal
              />
            }
          />
          <Route
            path="flyout/:cloud/products-listing"
            element={
              <LayoutWrapper
                title=""
                component={() => (
                  <BaseRouteWithAccountRedirect
                    product="flyout"
                    resource="products-listing"
                  />
                )}
                isExternal
              />
            }
          />
          <Route
            path="flyout/:cloud/:accountId/products-listing"
            element={
              <LayoutWrapper
                title=""
                component={ImpartnerProductListingWrapper}
                isExternal
              />
            }
          />
          <Route
            path="flyout/:cloud/:accountId/products-listing/edit"
            element={
              <NoHeaderLayoutWrapper
                component={AddEditProductListingWrapper}
                actions={SelectedCloudIcon}
                isSidePanelOpened={false}
                isExternal
              />
            }
          />
          <Route
            path="flyout/:cloud/:accountId/products-listing/:productId/edit"
            element={
              <NoHeaderLayoutWrapper
                component={AddEditProductListingWrapper}
                actions={SelectedCloudIcon}
                isSidePanelOpened={false}
                isExternal
              />
            }
          />
          <Route
            path="flyout/:cloud/:accountId/products-listing/:productId/details"
            element={
              <NoHeaderLayoutWrapper
                component={DetailProductListing}
                actions={SelectedCloudIcon}
                isSidePanelOpened={false}
                isExternal
              />
            }
          />
        </Routes>
      </Suspense>
    </PartnerAccountDataProvider>
  )
}

export default ExternalPartnerRoutes
